package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * Paid-promotion plans a business owner can buy to boost placement. The `id` + price + duration MUST
 * stay in sync with `PROMOTION_PLANS` in `firebase/functions/index.js` — the Function is the source of
 * truth for the actual charge; [priceCents] here is display-only. Labels are localized in the feature
 * (string resources keyed by [id]). Prices are placeholders until the owner sets the real numbers.
 */
enum class PromotionPlan(val id: String, val priceCents: Long, val days: Int, val scope: SponsorshipScope) {
    CityWeek("promote_city_7d", 999, 7, SponsorshipScope.City),
    CityMonth("promote_city_30d", 2999, 30, SponsorshipScope.City),
    TopMonth("promote_top_30d", 7999, 30, SponsorshipScope.Top);

    companion object {
        val all: List<PromotionPlan> = entries
        fun fromId(id: String): PromotionPlan? = entries.firstOrNull { it.id == id }
    }
}
